import { useEffect, useState } from "react";
import "../../ncd/components/FollowupTreatment.css";
import { ncdAPI } from "../../../services/ncd.api";
import { pmndpAPI } from "../../../services/pmndp.api";
import { uwinAPI } from "../../../services/uwin.api";
import { nikshayAPI } from "../../../services/nikshay.api";

import {
    handleGetRefreshToken,
    handlePatientTestDetails
} from "../../sickle/components/Sickleform";

import TimelineLoader from '../../../components/Loader/TimelineLoader';
import HorizontalScroller from "../../../components/HorizontalScroller";
import dayjs from "dayjs";
import { formatToApiDate } from "../../../helpers/common-helper";

export default function Timeline({ individualId, parsedBeneficiary, nikshayData }) {

    const [isTableLoading, setTableLoading] = useState(false);
    const [patientTestDetails, setPatientTestDetails] = useState([]);
    const [dialysisHistory, setDialysisHistory] = useState(null);
    const [SickleAbhaAvailabilityData] = useState(null);
    const [vitals, setVitals] = useState(null);
    const [currentmedicines, setMedicines] = useState(null);
    const [uwinVaccinations, setUwinVaccinations] = useState(null);
    const [nikshayEpisodeDetails, setNikshayEpisodeDetails] = useState(null);
    const [nikshayTestData, setNikshayTestData] = useState(null);
    const [tests, setTests] = useState([]);

    useEffect(() => {
        if (!nikshayData?.Id) return;
        const fetchNikshayData = async () => {
            try {
                const testRes = await nikshayAPI.getTest(nikshayData.Id);

                const refRes = await nikshayAPI.getDataAgainByRefId(testRes?.Data?.RefId);

                const rawResponse = refRes?.data?.json_received?.Data?.Response;

                if (!rawResponse) {
                    setTests([]);
                    return;
                }

                const parsed = typeof rawResponse === "string" ? JSON.parse(rawResponse) : rawResponse;
                setTests(Array.isArray(parsed) ? parsed : []);

                console.log('nikshay timeline data', parsed);

            } catch (err) {
                console.error("Error fetching refId on Patient Details load:", err);
            }
        };
        fetchNikshayData();
    }, [nikshayData?.Id]);

    const extractValidDate = (vaccine) => {
        if (!vaccine) return "";

        if (vaccine.vaccination_date && vaccine.vaccination_date.trim() !== "") {
            return vaccine.vaccination_date;
        }
        if (vaccine.nextDueDate && vaccine.nextDueDate.trim() !== "") {
            return vaccine.nextDueDate;
        }
        if (vaccine.due_date_iso && vaccine.due_date_iso.trim() !== "") {
            return vaccine.due_date_iso;
        }
        if (vaccine.due_date && /\d/.test(vaccine.due_date)) {
            return vaccine.due_date;
        }
        return "";
    };

    const formatMonth = (dateStr) => {
        if (!dateStr) return "";
        const cleanStr = String(dateStr).trim().replace(" ", "T");

        if (/^\d{4}-\d{2}-\d{2}/.test(cleanStr)) {
            const d = dayjs(cleanStr);
            if (d.isValid()) return d.format("MMM");
        }

        const parts = cleanStr.split(/[-/]/);
        if (parts.length >= 3) {
            const [p1, p2, p3] = parts;
            if (p3.length === 4) {
                const d = dayjs(`${p3}-${p2}-${p1}`);
                if (d.isValid()) return d.format("MMM");
            } else if (p1.length === 4) {
                const d = dayjs(`${p1}-${p2}-${p3.split("T")[0]}`);
                if (d.isValid()) return d.format("MMM");
            }
            const parsed = dayjs(cleanStr, ["DD-MMM-YYYY", "DD/MMM/YYYY", "DD-MM-YYYY", "DD/MM/YYYY"]);
            if (parsed.isValid()) return parsed.format("MMM");
        }

        const d = dayjs(cleanStr);
        return d.isValid() ? d.format("MMM") : "";
    };

    const formatYear = (dateStr) => {
        if (!dateStr) return "";
        const cleanStr = String(dateStr).trim().replace(" ", "T");

        if (/^\d{4}-\d{2}-\d{2}/.test(cleanStr)) {
            const d = dayjs(cleanStr);
            if (d.isValid()) return d.format("YYYY");
        }

        const parts = cleanStr.split(/[-/]/);
        if (parts.length >= 3) {
            const [p1, p2, p3] = parts;
            if (p3.length === 4) {
                return p3.split("T")[0];
            } else if (p1.length === 4) {
                return p1;
            }
            const parsed = dayjs(cleanStr, ["DD-MMM-YYYY", "DD/MMM/YYYY", "DD-MM-YYYY", "DD/MM/YYYY"]);
            if (parsed.isValid()) return parsed.format("YYYY");
        }

        const d = dayjs(cleanStr);
        return d.isValid() ? d.format("YYYY") : "";
    };

    const getNikshayDataObj = () => {
        const epData =
            nikshayEpisodeDetails?.episodeData ||
            nikshayEpisodeDetails?.data?.episodeData ||
            nikshayData?.data?.episodeData ||
            nikshayData?.episodeData ||
            (nikshayData?.createdDate ? nikshayData : null) ||
            (nikshayEpisodeDetails?.createdDate ? nikshayEpisodeDetails : null);

        const overview =
            nikshayEpisodeDetails?.overview ||
            nikshayEpisodeDetails?.data?.overview ||
            nikshayData?.data?.overview ||
            nikshayData?.overview ||
            [];

        const createdDate =
            epData?.createdDate ||
            nikshayEpisodeDetails?.createdDate ||
            nikshayEpisodeDetails?.data?.createdDate ||
            nikshayData?.data?.episodeData?.createdDate ||
            nikshayData?.createdDate ||
            nikshayData?.DateOfEnrollment ||
            tests?.[0]?.RequestDate ||
            null;

        const stageName =
            epData?.stageName ||
            nikshayEpisodeDetails?.stageName ||
            overview?.[2]?.status ||
            overview?.[0]?.status ||
            nikshayData?.data?.overview?.[2]?.status ||
            nikshayData?.stageName ||
            nikshayData?.Stage ||
            (epData ? "Presumptive (Open)" : null);

        let testList = (tests && tests.length > 0) ? tests : (nikshayTestData?.parsedTests || []);
        if (testList.length === 0) {
            const rawRes =
                nikshayTestData?.data?.json_received?.Data?.Response ||
                nikshayTestData?.json_received?.Data?.Response ||
                nikshayData?.data?.json_received?.Data?.Response ||
                nikshayData?.json_received?.Data?.Response ||
                nikshayData?.Data?.Response;
            if (rawRes) {
                try {
                    testList = typeof rawRes === "string" ? JSON.parse(rawRes) : Array.isArray(rawRes) ? rawRes : [];
                } catch (e) {
                    console.error("Error parsing test response JSON:", e);
                }
            }
        }

        return {
            epData,
            overview,
            createdDate,
            stageName,
            testList
        };
    };

    const formatTestTimelineLabel = (test) => {
        const testType = test.TestType || "TB Test";
        if (test.FinalInterpretation) {
            let interp = test.FinalInterpretation.trim();
            if (interp.toLowerCase().includes("m.tb. detected") || interp.toLowerCase().includes("tb detected")) {
                interp = "M.Tb. Detected";
            } else if (interp.toLowerCase().includes("not detected")) {
                interp = "TB Not Detected";
            } else if (interp.length > 20) {
                interp = interp.substring(0, 20) + "...";
            }
            return `${testType}: ${interp}`;
        }
        return `${testType}: ${test.Status || "Requested"}`;
    };

    const getMonthDifference = (givenDateStr) => {
        if (!givenDateStr) return "0 months";

        let givenDate;
        if (/^\d{4}-\d{2}-\d{2}/.test(givenDateStr)) {
            givenDate = new Date(givenDateStr);
        } else {
            const parts = givenDateStr.split(/[-/]/);
            if (parts.length === 3) {
                const [day, month, year] = parts;
                const y = year.length === 4 ? year : day;
                const d = year.length === 4 ? day : year;
                givenDate = new Date(`${y}-${month}-${d}`);
            } else {
                givenDate = new Date(givenDateStr);
            }
        }

        const currentDate = new Date();
        if (isNaN(givenDate.getTime())) return "Invalid date";

        let months =
            (currentDate.getFullYear() - givenDate.getFullYear()) * 12 +
            (currentDate.getMonth() - givenDate.getMonth());

        if (currentDate.getDate() < givenDate.getDate()) {
            months--;
        }

        months = Math.max(0, months);
        return `${months} month${months === 1 ? "" : "s"}`;
    };


    useEffect(() => {
        const getVitals = async () => {
            try {
                setTableLoading(true);
                if (individualId) {
                    await fetchVitals();
                }
            } catch (error) {
                console.error('Error fetching vitals:', error);
            } finally {
                setTableLoading(false);
            }
        };

        if (individualId) {
            getVitals();
        }
    }, [individualId]);

    useEffect(() => {
        if (SickleAbhaAvailabilityData?.sickle_id) {
            getSickleTimeLine();
        }
    }, [SickleAbhaAvailabilityData]);

    useEffect(() => {
        handleGetDialysisHistory();
        handleGetUwinVaccinations();
        handleGetNikshayData();
    }, [parsedBeneficiary, nikshayData]);

    const handleGetUwinVaccinations = async () => {
        try {
            let searchValue = "";
            let searchBy = "";

            if (parsedBeneficiary?.originalabha) {
                searchValue = parsedBeneficiary.originalabha;
                searchBy = "abha-number";
            } else if (parsedBeneficiary?.mobile) {
                searchValue = parsedBeneficiary.mobile;
                searchBy = "mobile-number";
            }

            if (!searchValue) return;

            let encryptedSearchValue = searchValue;
            try {
                const resEncrypt = await uwinAPI.encryptText({ plaintext: searchValue });
                encryptedSearchValue = resEncrypt?.data?.encrypted || resEncrypt?.encrypted || searchValue;
            } catch (e) {
                console.error("Encryption error for UWIN search:", e);
            }

            const resp = await uwinAPI.searchBeneficiary({
                search_value: encryptedSearchValue,
                search_by: searchBy
            });

            if (resp?.success && resp?.data?.length > 0) {
                let matchedProfile = resp.data[0];
                if (resp.data.length > 1 && parsedBeneficiary?.mobile) {
                    matchedProfile = resp.data.find(item =>
                        item.ben_mobile_number == parsedBeneficiary.mobile &&
                        item.ben_name == parsedBeneficiary.name
                    ) || resp.data[0];
                }

                const benRefId = matchedProfile?.beneficiary_reference_id || matchedProfile?.beneficiary_ref_id || matchedProfile?.beneficiary_id;

                if (benRefId) {
                    const vaccineResponse = await uwinAPI.getVaccinations({
                        beneficiary_ref_id: benRefId,
                        lmc_date: matchedProfile?.lmc_date
                    });

                    if (vaccineResponse?.success && vaccineResponse?.data) {
                        setUwinVaccinations(vaccineResponse.data);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching U-WIN vaccinations:", error);
        }
    };

    const handleGetNikshayData = async () => {
        try {
            let episodeId =
                nikshayData?.data?.episodeData?.id ||
                nikshayData?.data?.episodes?.[0] ||
                nikshayData?.data?.overview?.[0]?.PatientId ||
                nikshayData?.EpisodeList?.[0]?.id ||
                nikshayData?.episodeData?.id ||
                nikshayData?.episodes?.[0];

            let refId = nikshayData?.data?.ref_id || nikshayData?.ref_id || episodeId;

            if (!episodeId && parsedBeneficiary?.originalabha) {
                try {
                    const searchResp = await nikshayAPI.getPatientsByHealthId({
                        healthId: parsedBeneficiary.originalabha
                    });
                    if (searchResp?.success && searchResp?.data?.EpisodeList?.[0]?.id) {
                        episodeId = searchResp.data.EpisodeList[0].id;
                        refId = refId || episodeId;
                    }
                } catch (searchErr) {
                    console.error("Error searching Nikshay patient by ABHA:", searchErr);
                }
            }

            if (episodeId) {
                try {
                    const epRes = await nikshayAPI.getEpisodeDetails(episodeId);
                    if (epRes?.success && epRes?.data) {
                        setNikshayEpisodeDetails(epRes.data);
                    } else if (nikshayData?.data) {
                        setNikshayEpisodeDetails(nikshayData.data);
                    }
                } catch (epErr) {
                    console.error("Error fetching Nikshay episode details:", epErr);
                    if (nikshayData?.data) {
                        setNikshayEpisodeDetails(nikshayData.data);
                    }
                }
            }

            if (refId) {
                try {
                    const testRes = await nikshayAPI.getDataAgainByRefId(refId);
                    if (testRes?.success && testRes?.data) {
                        let parsedTests = [];
                        try {
                            const rawResponse = testRes.data?.json_received?.Data?.Response;
                            if (typeof rawResponse === "string") {
                                parsedTests = JSON.parse(rawResponse);
                            } else if (Array.isArray(rawResponse)) {
                                parsedTests = rawResponse;
                            }
                        } catch (e) {
                            console.error("Error parsing Nikshay test JSON response:", e);
                        }
                        setNikshayTestData({ ...testRes.data, parsedTests });
                    }
                } catch (testErr) {
                    console.error("Error fetching Nikshay test data:", testErr);
                }
            }
        } catch (err) {
            console.error("Error in handleGetNikshayData:", err);
        }
    };

    const fetchVitals = async () => {
        try {
            if (!individualId) {
                return;
            }

            const vitalsData = await ncdAPI.getLeftPanel(individualId);

            // Extract sugarVitals & bpVitals
            const latestSugarVitals = vitalsData?.data?.sugarVitals;
            const latestBpVitals = vitalsData?.data?.bpVitals;
            const historydate = vitalsData?.data?.patientHistoryAssessmentDate;
            const patientHistory = vitalsData?.data?.patientHistory;

            setVitals({
                historydate,
                patientHistory,
                latestSugarVitals,
                latestBpVitals,
            });

            const med = vitalsData?.data?.currentMedicationSummary;

            setMedicines(med);

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setTableLoading(false); // Always executed
        }
    };

    const getSickleTimeLine = async () => {
        const sickleRefreshTokenData = await handleGetRefreshToken(
            localStorage.getItem("sickle_refresh_token")
        );
        if (sickleRefreshTokenData?.responseMetaData) {
            if (
                sickleRefreshTokenData.responseMetaData.responseStatusCode === 200 ||
                sickleRefreshTokenData.responseMetaData.message === "Success"
            ) {
                localStorage.setItem(
                    "sickle_token",
                    sickleRefreshTokenData.result.token
                );
                if (SickleAbhaAvailabilityData?.sickle_id) {
                    const patientTestDetails = await handlePatientTestDetails(
                        sickleRefreshTokenData.result.token,
                        SickleAbhaAvailabilityData
                    );
                    if (
                        patientTestDetails.Status === 200 &&
                        patientTestDetails.Message === "Success"
                    ) {
                        setPatientTestDetails(patientTestDetails.PatientDetails);
                    }
                } else {
                    console.error("Sickle ID Missing");
                }
            }
        } else {
            console.error("Invalid sickleRefreshTokenData:", sickleRefreshTokenData);
        }
    };

    const handleGetDialysisHistory = async () => {
        try {
            if (parsedBeneficiary.originalabha) {
                // Fetch the dialysis history data
                const responseDailysisHistory = await pmndpAPI.getDialysisHistory({
                    abhaId: parsedBeneficiary.originalabha,
                    page: 1,
                    pageSize: 10
                });

                if (responseDailysisHistory.success) {
                    const dataGet = responseDailysisHistory.data.dataGet;

                    if (dataGet?.length > 0) {

                        const validhistory = dataGet.find(
                            (item) =>
                                item.status === "Complete" &&
                                item.heomoglobin !== null &&
                                item.heomoglobin !== undefined &&
                                item.heomoglobin !== "" &&
                                item.heomoglobin !== "null"
                        );

                        setDialysisHistory(validhistory);
                    } else {
                        // toast.info("No Dialysis History Found");
                    }
                } else {
                    //  toast.info("No Dialysis History Found");
                }
            } else {
                // toast.info("ABHA not linked");
            }
        } catch (error) {
            //toast.error("Error fetching dialysis history");
        }
    };

    const patientHistory = vitals?.patientHistory || [];

    const getStatus = (disease) => patientHistory.includes(disease) ? "Present" : "Absent";

    return (
        <>
            <div className="beneficiaryTabs">
                <ul className="nav nav-pills">
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            data-bs-toggle="pill"
                            href="#TImeline"
                        >
                            <img
                                src="/images/calander.svg"
                                alt=""
                                className="mx-2"
                                style={{ width: "16px" }}
                            />
                            Timeline
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            data-bs-toggle="pill"
                            href="#HealthProfile"
                        >
                            <img
                                src="/images/frame medication history.svg"
                                alt=""
                                className="mx-2"
                                style={{ width: "16px" }}
                            />
                            Health Profile
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link nav_link_sp"
                            data-bs-toggle="pill"
                            href="#MedicationHistory"
                        >
                            <img
                                src="/images/Frame health profile.svg"
                                alt=""
                                className="mx-1"
                                style={{ width: "16px" }}
                            />
                            Medication History
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            data-bs-toggle="pill"
                            href="#FamilyHistory"
                        >
                            <img
                                src="/images/frame Family history.svg"
                                alt=""
                                className="mx-2"
                                style={{ width: "16px" }}
                            />
                            Family History
                        </a>
                    </li>
                </ul>
                {/* Tab panes */}
                <div className="tab-content">
                    <div
                        className="tab-pane container beneficiaryTabsBody active"
                        id="TImeline"
                    >
                        <div className="beneficiaryTimeline">

                            {isTableLoading ? (
                                <TimelineLoader />
                            ) : (
                                <>
                                    <div className="beneficiaryTimilineRow">
                                        <ul>
                                            {vitals?.historydate &&
                                                vitals?.patientHistory?.length > 0 &&
                                                vitals.patientHistory.map((history, index) => {

                                                    return (
                                                        <li key={index}>
                                                            <p className="montName">{formatMonth(vitals.historydate)}</p>
                                                            <p className="yearName">{formatYear(vitals.historydate)}</p>
                                                            <span className="timelineCircleDot">
                                                                &nbsp;
                                                            </span>
                                                            <p className="timilineProgramName">
                                                                {history}
                                                            </p>
                                                        </li>
                                                    );
                                                })}


                                            {(() => {
                                                const { createdDate, stageName, testList } = getNikshayDataObj();
                                                return (
                                                    <>
                                                        {testList.length === 0 && createdDate && (
                                                            <li>
                                                                <p className="montName">{formatMonth(createdDate)}</p>
                                                                <p className="yearName">{formatYear(createdDate)}</p>
                                                                <span className="timelineCircleDot">&nbsp;</span>
                                                                <p className="timilineProgramName">
                                                                    {stageName || "TB Registration"} (Ni-kshay)
                                                                </p>
                                                            </li>
                                                        )}

                                                        {testList.length > 0 &&
                                                            testList.map((test, index) => {
                                                                const testDate = test.RequestDate || test.created_at;
                                                                const displayResult = formatTestTimelineLabel(test);
                                                                return (
                                                                    <li key={`nikshay-test-${index}`}>
                                                                        <p className="montName">{formatMonth(testDate)}</p>
                                                                        <p className="yearName">{formatYear(testDate)}</p>
                                                                        <span className="timelineCircleDot">&nbsp;</span>
                                                                        <p className="timilineProgramName">
                                                                            {displayResult} (Ni-kshay)
                                                                        </p>
                                                                    </li>
                                                                );
                                                            })}
                                                    </>
                                                );
                                            })()}

                                            {patientTestDetails[0]?.last_screening ? (
                                                <li>
                                                    <p className="montName">
                                                        {formatMonth(
                                                            patientTestDetails[0]?.last_screening
                                                                ?.ResultDate
                                                        )}
                                                    </p>
                                                    <p className="yearName">
                                                        {formatYear(
                                                            patientTestDetails[0]?.last_screening
                                                                ?.ResultDate
                                                        )}
                                                    </p>
                                                    <span className="timelineCircleDot">
                                                        &nbsp;
                                                    </span>
                                                    <p className="timilineProgramName">
                                                        {
                                                            patientTestDetails[0]?.last_screening
                                                                ?.disease_name
                                                        }
                                                    </p>
                                                </li>
                                            ) : patientTestDetails[0]?.last_confiramatory ? (
                                                <li>
                                                    <p className="montName">
                                                        {formatMonth(
                                                            patientTestDetails[0]?.last_confiramatory
                                                                ?.ResultDate
                                                        )}
                                                    </p>
                                                    <p className="yearName">
                                                        {formatYear(
                                                            patientTestDetails[0]?.last_confiramatory
                                                                ?.ResultDate
                                                        )}
                                                    </p>
                                                    <span className="timelineCircleDot">
                                                        &nbsp;
                                                    </span>
                                                    <p className="timilineProgramName">
                                                        {
                                                            patientTestDetails[0]?.last_confiramatory
                                                                ?.disease_name
                                                        }
                                                    </p>
                                                </li>
                                            ) : null}

                                            {uwinVaccinations?.vaccinationDetails?.length > 0 &&
                                                uwinVaccinations.vaccinationDetails
                                                    .filter(v => extractValidDate(v))
                                                    .map((vaccine, index) => {
                                                        const dateStr = extractValidDate(vaccine);
                                                        const isVaccinated = !!vaccine.vaccination_date;
                                                        const doseName = vaccine.display_dose_name || vaccine.Vaccine || vaccine.material_name;
                                                        const label = isVaccinated
                                                            ? `${doseName} - Vaccinated (U-WIN)`
                                                            : `${doseName} - Due (U-WIN)`;

                                                        return (
                                                            <li key={`uwin-${index}`}>
                                                                <p className="montName">{formatMonth(dateStr)}</p>
                                                                <p className="yearName">{formatYear(dateStr)}</p>
                                                                <span className="timelineCircleDot">
                                                                    &nbsp;
                                                                </span>
                                                                <p className="timilineProgramName">
                                                                    {label}
                                                                </p>
                                                            </li>
                                                        );
                                                    })}

                                            {!vitals?.historydate &&
                                                !patientTestDetails[0]?.last_screening &&
                                                !patientTestDetails[0]?.last_confiramatory &&
                                                !getNikshayDataObj().createdDate &&
                                                !getNikshayDataObj().testList.length &&
                                                !uwinVaccinations?.vaccinationDetails?.some(v => extractValidDate(v)) && (
                                                    <>
                                                        <li>
                                                            <p className="montName">Month</p>
                                                            <p className="yearName">Year</p>
                                                            <span className="timelineCircleDot">
                                                                &nbsp;
                                                            </span>
                                                            <p className="timilineProgramName">
                                                                No data available
                                                            </p>
                                                        </li>
                                                        <li>
                                                            <p className="montName">Month</p>
                                                            <p className="yearName">Year</p>
                                                            <span className="timelineCircleDot">
                                                                &nbsp;
                                                            </span>
                                                            <p className="timilineProgramName">
                                                                No data available
                                                            </p>
                                                        </li>
                                                        <li>
                                                            <p className="montName">Month</p>
                                                            <p className="yearName">Year</p>
                                                            <span className="timelineCircleDot">
                                                                &nbsp;
                                                            </span>
                                                            <p className="timilineProgramName">
                                                                No data available
                                                            </p>
                                                        </li>
                                                    </>
                                                )}
                                        </ul>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div
                        className="tab-pane container beneficiaryTabsBody fade"
                        id="HealthProfile"
                    >
                        <div className="beneficiaryTimeline">

                            {isTableLoading ? (
                                <TimelineLoader />
                            ) : (
                                <>

                                    <HorizontalScroller>

                                        {vitals?.latestBpVitals?.sys && (

                                            <div className="beneficiaryTabsBodyCol">
                                                <div className="benHeader">
                                                    <img src="/images/NCD.svg" alt="NCD" />
                                                    <h4>NCD</h4>
                                                    <div className="beniDate">
                                                        <p>{formatMonth(vitals.latestBpVitals.assesDate)}{" "}
                                                            {formatYear(vitals.latestBpVitals.assesDate)} - Hypertension</p>
                                                    </div>
                                                    <span className="notiFey yellowBg">{getMonthDifference(vitals.latestBpVitals.assesDate)}</span>
                                                </div>

                                                <div className="beniDataList">

                                                    <div className="beniDataListRow">
                                                        <div className="title">Systolic (mmHg)</div>
                                                        <div className="values danger">
                                                            {vitals.latestBpVitals.sys}
                                                        </div>
                                                    </div>
                                                    <div className="beniDataListRow">
                                                        <div className="title">
                                                            Diastolic (mmHg)
                                                        </div>
                                                        <div className="values danger">
                                                            {vitals.latestBpVitals.diast}
                                                        </div>
                                                    </div>
                                                    <div className="beniDataListRow">
                                                        <div className="title">R.B.S. (mg/dl)</div>
                                                        <div className="values danger">
                                                            {vitals.latestSugarVitals?.rndBldGlc ??
                                                                ""}
                                                        </div>
                                                    </div>
                                                    <div className="beniDataListRow border-top">
                                                        <div className="title">Pulse Rate</div>
                                                        <div className="values dark">
                                                            {vitals.latestBpVitals.heartRate ?? ""}{" "}
                                                            BPM
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {(patientTestDetails[0]?.last_screening || patientTestDetails[0]?.lastConfirmatory) && (
                                            <div className="beneficiaryTabsBodyCol">
                                                <div className="benHeader">
                                                    <img src="/images/Sickel.svg" alt="Sickle Cell" />
                                                    <h4>Sickle Cell</h4>

                                                    {patientTestDetails[0]?.last_screening && (
                                                        <>
                                                            <div className="beniDate">
                                                                <p>Sep 22</p>
                                                            </div>
                                                            <span className="notiFey yellowBg">1 Y 11 M</span>
                                                        </>
                                                    )}
                                                </div>

                                                <div className="beniDataList">
                                                    {patientTestDetails[0]?.last_screening ? (
                                                        <>
                                                            <div className="beniDataListRow">
                                                                <div className="title">Test Method</div>
                                                                <div className="values danger">
                                                                    {patientTestDetails[0].last_screening.method_name}
                                                                </div>
                                                            </div>
                                                            <div className="beniDataListRow">
                                                                <div className="title">Test Result</div>
                                                                <div className="values dark">
                                                                    {patientTestDetails[0].last_screening.result_name}
                                                                </div>
                                                            </div>
                                                            <div className="beniDataListRow">
                                                                <div className="title">Date Of Result</div>
                                                                <div className="values normal">
                                                                    {formatToApiDate(patientTestDetails[0].last_screening.ResultDate)}
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="beniDataListRow">
                                                                <div className="title">Test Method</div>
                                                                <div className="values danger">
                                                                    {patientTestDetails[0].lastConfirmatory.method_name}
                                                                </div>
                                                            </div>
                                                            <div className="beniDataListRow">
                                                                <div className="title">Test Result</div>
                                                                <div className="values dark">
                                                                    {patientTestDetails[0].lastConfirmatory.result_name}
                                                                </div>
                                                            </div>
                                                            <div className="beniDataListRow">
                                                                <div className="title">Date Of Result</div>
                                                                <div className="values normal">
                                                                    {formatToApiDate(patientTestDetails[0].lastConfirmatory.ResultDate)}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {(() => {
                                            const { epData, overview, createdDate, stageName, testList } = getNikshayDataObj();
                                            if (!epData && !stageName && testList.length === 0) return null;

                                            const patientId = overview?.[0]?.PatientId || epData?.id || testList?.[0]?.PatientId;
                                            const caseFinding = epData?.stageData?.typeOfCaseFinding;

                                            return (
                                                <div className="beneficiaryTabsBodyCol">
                                                    <div className="benHeader">
                                                        <img src="/images/programs_logo/nikshay.svg" alt="Ni-kshay" />
                                                        <h4>Ni-kshay</h4>
                                                        {(createdDate || testList?.[0]?.RequestDate) && (
                                                            <div className="beniDate">
                                                                <p>
                                                                    {formatMonth(createdDate || testList?.[0]?.RequestDate)}{" "}
                                                                    {formatYear(createdDate || testList?.[0]?.RequestDate)} - TB
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="beniDataList" style={{ maxHeight: "230px", overflowY: "auto", paddingRight: "4px" }}>
                                                        
                                                        {testList.length > 0 && testList.map((test, index) => (
                                                            <div key={`nikshay-hp-test-${index}`} style={{
                                                                marginTop: index > 0 ? "8px" : "0",
                                                                paddingTop: index > 0 ? "6px" : "0",
                                                                borderTop: index > 0 ? "1px dashed #d0d0d0" : "none"
                                                            }}>
                                                                {testList.length > 1 && (
                                                                    <div style={{ fontWeight: "600", color: "#0056b3", fontSize: "11px", marginBottom: "4px", display: "flex", justifyContent: "space-between" }}>
                                                                        <span>Test #{index + 1}: {test.TestType || "TB Test"}</span>
                                                                        <span style={{ fontSize: "10px", color: "#666" }}>{test.RequestDate || ""}</span>
                                                                    </div>
                                                                )}
                                                                {test.TestType && (
                                                                    <div className="beniDataListRow" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px", padding: "2px 0" }}>
                                                                        <div className="title" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>Test Type</div>
                                                                        <div className="values dark" style={{ textAlign: "right" }}>{test.TestType}</div>
                                                                    </div>
                                                                )}
                                                               
                                                                {test.FinalInterpretation && (
                                                                    <div className="beniDataListRow" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px", padding: "2px 0" }}>
                                                                        <div className="title" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>Result</div>
                                                                        <div className="values danger" style={{ textAlign: "right", wordBreak: "break-word" }}>{test.FinalInterpretation}</div>
                                                                    </div>
                                                                )}
                                                                {test.SampleType && (
                                                                    <div className="beniDataListRow" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px", padding: "2px 0" }}>
                                                                        <div className="title" style={{ flexShrink: 0, whiteSpace: "nowrap" }}>Sample Type</div>
                                                                        <div className="values dark" style={{ textAlign: "right" }}>{test.SampleType}</div>
                                                                    </div>
                                                                )}
                                                               
                                                            </div>
                                                        ))}
                                                        {caseFinding && (
                                                            <div className="beniDataListRow">
                                                                <div className="title">Case Finding</div>
                                                                <div className="values dark">{caseFinding}</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })()}

                                        {uwinVaccinations && (
                                            <div className="beneficiaryTabsBodyCol">
                                                <div className="benHeader">
                                                    <img src="/images/programs_logo/uwin.svg" alt="U-WIN" />
                                                    <h4>U-WIN</h4>
                                                    {uwinVaccinations?.next_due_date && (
                                                        <>
                                                            <div className="beniDate">
                                                                <p>{uwinVaccinations.next_due_date} - Immunization</p>
                                                            </div>
                                                            <span className="notiFey yellowBg">
                                                                {getMonthDifference(uwinVaccinations.next_due_date)}
                                                            </span>
                                                        </>
                                                    )}
                                                </div>

                                                <div className="beniDataList">
                                                    {uwinVaccinations.ben_name && (
                                                        <div className="beniDataListRow">
                                                            <div className="title">Beneficiary Name</div>
                                                            <div className="values dark">{uwinVaccinations.ben_name}</div>
                                                        </div>
                                                    )}
                                                    {uwinVaccinations.guardian_name && (
                                                        <div className="beniDataListRow">
                                                            <div className="title">Guardian Name</div>
                                                            <div className="values dark">{uwinVaccinations.guardian_name}</div>
                                                        </div>
                                                    )}
                                                    {uwinVaccinations.next_due_date && (
                                                        <div className="beniDataListRow">
                                                            <div className="title">Next Due Date</div>
                                                            <div className="values danger">{uwinVaccinations.next_due_date}</div>
                                                        </div>
                                                    )}
                                                    {uwinVaccinations.beneficiary_gender && (
                                                        <div className="beniDataListRow">
                                                            <div className="title">Gender</div>
                                                            <div className="values dark">{uwinVaccinations.beneficiary_gender}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {dialysisHistory && (
                                            <div className="beneficiaryTabsBodyCol">
                                                <div className="benHeader">
                                                    <img src="/images/programs_logo/pmndp.svg" alt="PMNDP" />
                                                    <h4>PMNDP</h4>
                                                    <div className="beniDate">
                                                        <p>
                                                            {formatMonth(dialysisHistory.appointment_date)}{" "}
                                                            {formatYear(dialysisHistory.appointment_date)} - Dialysis
                                                        </p>
                                                    </div>
                                                    <span className="notiFey yellowBg">
                                                        {getMonthDifference(dialysisHistory.appointment_date)}
                                                    </span>
                                                </div>

                                                <div className="beniDataList">
                                                    <div className="beniDataListRow">
                                                        <div className="title">Hemoglobin</div>
                                                        <div className="values danger">
                                                            {dialysisHistory.heomoglobin}
                                                        </div>
                                                    </div>
                                                    <div className="beniDataListRow">
                                                        <div className="title">Pre/Post Blood Pressure</div>
                                                        <div className="values danger">
                                                            {dialysisHistory.pre_blood_pressure}/{dialysisHistory.post_blood_pressure}
                                                        </div>
                                                    </div>
                                                    <div className="beniDataListRow">
                                                        <div className="title">Pre/Post Weight</div>
                                                        <div className="values danger">
                                                            {dialysisHistory.pre_weight}/{dialysisHistory.post_weight}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </HorizontalScroller>

                                </>
                            )}

                        </div>
                    </div>
                    <div
                        className="tab-pane container beneficiaryTabsBody fade"
                        id="MedicationHistory"
                    >
                        <div className="beneficiaryTimeline">

                            {isTableLoading ? (
                                <TimelineLoader />
                            ) : (
                                <>
                                    <HorizontalScroller>
                                        <div className="beneficiaryTabsBodyCol">
                                            <div className="benHeader">
                                                <img src="/images/NCD.svg" alt="NCD" />
                                                <h4>NCD</h4>
                                                {/* <div className="beniDate">
                                                                        <p>Jun 24 - Hypertension</p>
                                                                    </div>
                                                                    <span className="notiFey yellowBg">2 months</span> */}
                                            </div>

                                            <div className="beniDataList">
                                                {currentmedicines?.medicines?.length > 0 ? (
                                                    currentmedicines.medicines
                                                        .slice(0, 4)
                                                        .map((medicine, index) => (
                                                            <div
                                                                className="beniDataListRow"
                                                                key={index}
                                                            >
                                                                <div className="title">
                                                                    {medicine.conditn}
                                                                </div>
                                                                <div className="values dark">
                                                                    {medicine.name}
                                                                </div>
                                                            </div>
                                                        ))
                                                ) : currentmedicines?.medicinesPrescribed
                                                    ?.length > 0 ? (
                                                    currentmedicines.medicinesPrescribed
                                                        .slice(0, 4)
                                                        .map((medicine, index) => (
                                                            <div
                                                                className="beniDataListRow"
                                                                key={index}
                                                            >
                                                                <div className="title">
                                                                    {medicine.conditn}
                                                                </div>
                                                                <div className="values dark">
                                                                    {medicine.name}
                                                                </div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div className="beniDataListRow">
                                                        <div className="title">
                                                            No medication data available
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {(() => {
                                            const { epData, stageName } = getNikshayDataObj();
                                            const hasNikshayData = !!(epData || stageName);

                                            return (
                                                <div className="beneficiaryTabsBodyCol">
                                                    <div className="benHeader">
                                                        <img src="/images/programs_logo/nikshay.svg" alt="Ni-kshay" />
                                                        <h4>Ni-kshay</h4>
                                                        {stageName && (
                                                            <div className="beniDate">
                                                                <p>{stageName}</p>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="beniDataList">
                                                        {hasNikshayData ? (
                                                            <>
                                                                {stageName && (
                                                                    <div className="beniDataListRow">
                                                                        <div className="title">Stage</div>
                                                                        <div className="values danger">{stageName}</div>
                                                                    </div>
                                                                )}
                                                                {epData?.stageData?.treatmentPhase && (
                                                                    <div className="beniDataListRow">
                                                                        <div className="title">Treatment Phase</div>
                                                                        <div className="values dark">{epData.stageData.treatmentPhase}</div>
                                                                    </div>
                                                                )}
                                                                {epData?.stageData?.hivTestStatus && (
                                                                    <div className="beniDataListRow">
                                                                        <div className="title">HIV Test Status</div>
                                                                        <div className="values dark">{epData.stageData.hivTestStatus}</div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div className="beniDataListRow">
                                                                <div className="title">No medication data available</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })()}

                                        <div className="beneficiaryTabsBodyCol">
                                            <div className="benHeader">
                                                <img src="/images/programs_logo/uwin.svg" alt="U-WIN" />
                                                <h4>U-WIN</h4>
                                                {uwinVaccinations?.next_due_date && (
                                                    <div className="beniDate">
                                                        <p>Next Due: {uwinVaccinations.next_due_date}</p>
                                                    </div>
                                                )}
                                            </div>

                                            <div
                                                className="beniDataList"
                                                style={{
                                                    maxHeight: "110px",
                                                    overflowY: "auto",
                                                    paddingRight: "4px"
                                                }}
                                            >
                                                {uwinVaccinations?.vaccinationDetails?.length > 0 ? (
                                                    uwinVaccinations.vaccinationDetails.map((vaccine, index) => {
                                                        const isVaccinated = !!vaccine.vaccination_date;
                                                        const isPending = vaccine.status === "pending" || vaccine.msg?.toLowerCase().includes("pending");
                                                        const dateVal = vaccine.nextDueDate || (/\d/.test(vaccine.due_date) ? vaccine.due_date : "");

                                                        let statusDisplay = "";
                                                        if (isVaccinated) {
                                                            statusDisplay = `Vaccinated (${vaccine.vaccination_date})`;
                                                        } else if (dateVal) {
                                                            statusDisplay = `Due: ${dateVal}${vaccine.msg ? ` - ${vaccine.msg}` : ''}`;
                                                        } else if (vaccine.msg) {
                                                            statusDisplay = vaccine.msg;
                                                        } else {
                                                            statusDisplay = "Not Administered";
                                                        }

                                                        return (
                                                            <div
                                                                className="beniDataListRow"
                                                                key={index}
                                                            >
                                                                <div className="title">
                                                                    {vaccine.display_dose_name || vaccine.Vaccine || vaccine.material_name}
                                                                    {vaccine.displayAge ? ` (${vaccine.displayAge})` : ''}
                                                                </div>
                                                                <div className={`values ${isVaccinated ? "normal" : isPending ? "danger" : "dark"}`}>
                                                                    {statusDisplay}
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="beniDataListRow">
                                                        <div className="title">
                                                            No medication data available
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </HorizontalScroller>
                                </>
                            )}

                        </div>
                    </div>
                    <div
                        className="tab-pane container beneficiaryTabsBody fade"
                        id="FamilyHistory"
                    >
                        <div className="beneficiaryTimeline">
                            <div className="beneficiaryTabsBodyRow">
                                <div className="beneficiaryTabsBodyCol beneficiaryFamilyHealthTabsBodyCol">
                                    <div className="beniDataList">
                                        <div className="beniDataListRow">
                                            <div className="values dark">Hypertension </div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className="values dark">Diabetic</div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className="values dark">Heart Disease</div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className="values dark">Tuberculosis </div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className="values dark">Sickle Cell </div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className="values dark">U-WIN Immunization </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="beneficiaryTabsBodyCol">
                                    <div className="beniDataList">

                                        <div className="beniDataListRow">
                                            <div className={`values ${vitals?.patientHistory?.includes("Hypertension") ? "success" : "danger"}`}>{getStatus("Hypertension")}</div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className={`values ${vitals?.patientHistory?.includes("Diabetes") ? "success" : "danger"}`}>{getStatus("Diabetes")}</div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className={`values ${vitals?.patientHistory?.includes("Heart Disease") ? "success" : "danger"}`}>{getStatus("Heart Disease")}</div>
                                        </div>
                                        {(() => {
                                            const { epData, stageName, testList } = getNikshayDataObj();
                                            const hasNikshayData = !!(epData || stageName || testList.length > 0 || nikshayData?.Stage);
                                            return (
                                                <div className="beniDataListRow">
                                                    <div className={`values ${hasNikshayData ? "success" : "danger"}`}>
                                                        {hasNikshayData ? "Present" : "Absent"}
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                        <div className="beniDataListRow">
                                            <div className="values default">N/A</div>
                                        </div>
                                        <div className="beniDataListRow">
                                            <div className={`values ${uwinVaccinations ? "success" : "danger"}`}>{uwinVaccinations ? "Present" : "Absent"}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

